import { connect, MapStateToProps, MergeProps } from "react-redux";

import { ConditionalMount, ConditionalMountProps } from "@multiweb/reactComponents";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getSectionComponent, MenuComponent } from "./selectors";

type StateProps = {
    sectionComponent?: MenuComponent;
};

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => ({
    sectionComponent: getSectionComponent(state),
});

const mergeProps: MergeProps<StateProps, undefined, NoneOwnProps, ConditionalMountProps> = ({ sectionComponent }) => ({
    mounted: !!sectionComponent,
    Component: sectionComponent,
});

/**
 * Vykreslí menu podle aktivní sekce.
 */
export const Menu = connect(mapStateToProps, undefined, mergeProps)(ConditionalMount);
